export function summarizeWhatsAppAuditDetail(status: string, errorReason?: string | null): string {
  if (!errorReason) return status === "failed" ? "Falha sem detalhe informado." : "—";

  const normalized = errorReason.toLowerCase();
  if (/['"]?exists['"]?\s*[:=]\s*false/.test(normalized)) {
    return "Número sem WhatsApp ou incorreto. O reenvio foi encerrado.";
  }
  if (normalized.includes("telefone do cliente inválido")) {
    return "Telefone inválido. Confira DDD e número no cadastro da cliente.";
  }
  if (normalized.includes("optou por não receber")) {
    return "Cliente optou por não receber mensagens pelo WhatsApp.";
  }
  if (normalized.includes("evolution api error 401") || normalized.includes("evolution api error 403")) {
    return "Acesso à Evolution API recusado. Revise as credenciais da integração.";
  }
  if (normalized.includes("evolution api não configurada")) {
    return "A integração Evolution API não está configurada para este salão.";
  }
  return errorReason;
}
